import styled from 'styled-components';
import { getSafeAreaValue } from '../../styled/theme/helpers/getSafeAreaValue';

export const BottomViewContainer = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-bottom: ${({ theme }) => getSafeAreaValue(theme, 'bottom', 0)};
`;

export const BottomViewHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.primary};
  position: relative;
`;

export const BottomViewHeaderTitle = styled.span`
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: 0 auto;
  padding: 0 40px;
`;

export const BottomViewCloseBtn = styled.div`
  position: absolute;
  right: 0;
  margin: 0 15px;
`;

export const BottomViewContent = styled.div`
  padding: 0 15px;
`;
